import React from 'react'
import { Link } from 'react-router-dom'
import Breadcumb from '../../Breadcumb/Main'
import BgImg from '../../../assets/images/work.jpg'

const WorkingAtBeet = () => {
    return (
        <>
            <Breadcumb Title="Working at BEET Technologies" Breadcumb="CAREERS" BgImg={BgImg} Extra={{backgroundPosition: 'center center'}} />
            <section className="section-padding--top section-padding--bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="section-title">
                                <p className="section-title__text">Life at BEET</p>
                                <h2 className="section-title__title">Small teams, real ownership, meaningful work</h2>
                            </div>
                            <div className="about-four__text" style={{marginBottom: 20}}>
                                As a consultant at BEET Technologies you work on products people use every day — from
                                commerce and connected services to the apps on their phones. Our clients are spread
                                across Europe and Africa, and our teams are deliberately small: you will never be a
                                cog in a machine, and your work will always be visible.
                            </div>
                            <div className="about-four__text" style={{marginBottom: 30}}>
                                We work hybrid from our hubs in Wolverhampton (UK), Malmö (Sweden), and Accra (Ghana),
                                and we approach every task the same way: keep it simple, be straightforward, fast,
                                and transparent.
                            </div>
                            <ul className="service-details__caption__list" style={{marginBottom: 40}}>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    Hybrid and flexible working from any of our three hubs
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    Small teams where your voice carries and your work ships
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    A modern toolchain and the freedom to improve it
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>
                                    Colleagues who share knowledge generously — it is part of the job, not a favour
                                </li>
                            </ul>
                            <Link to="/careers" className="thm-btn"><span>View Open Roles</span></Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default WorkingAtBeet
